import { render, staticRenderFns } from "./JournalEntries.vue?vue&type=template&id=4497a3b0"
import script from "./JournalEntries.vue?vue&type=script&lang=js"
export * from "./JournalEntries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports